import StatusItem from '../status-item/status-item'
import { StatusCardInterface } from '../../../models/interfaces/status-card-interface.interface'

interface StatusCardProps{
  items?:StatusCardInterface[]
}

function StatusCard({items=[],...props}:StatusCardProps) {
  return (
    <div className='polymer-status-card'>
      
      {
        items.map((item,_index)=>{
          const key = _index;
          return (
            <div className='polymer-status-card__content-container' key={key}>
              <div className='polymer-status-card__content-container-left'>
                <StatusItem variant={item.variant} isActive={item.isActive}/>
              </div>
              <div className='polymer-status-card__content-container-right'>
                <p className='polymer-status-card__content-container-right__title' style={{color: (item.isActive || item.variant === "default") ? "#323232" : "#757575"}}>{item.title}</p>
                {/* <p className='polymer-status-card__content-container-right__title' style={{color: blackColorTitleVariants.includes(item?.variant ?? "") ? "#323232" : "#AAAAAA"}}>{item.title}</p> */}
                <div className='polymer-status-card__content-container-right__description' />
                {item.description}
                {/* <p className='polymer-status-card__content-container-right__description'>{item.description}</p> */}
              </div>
              {_index < items.length - 1 && <div className={`polymer-status-card__content-separator-bottom ${items[_index].isActive ? 'polymer-status-card__content-separator-active' : 'polymer-status-card__content-separator-inactive'}`}/>}
            </div>
          )
        })
      }

      
      
    </div>
  )
}

export default StatusCard